import { CustomSelect } from "../../../components/custom-select.component";
import { SelectProps } from "../../form-types";
import {
	ClientEntityType,
	SupabaseReadTableEnum,
} from "../../../../../lib/supabase/supabaseTypes";
import { useDatabaseFetch } from "../../../hooks/useDatabase";
import { useCentralStore } from "../../../store/Central";
import {
	getClientDisplayName,
	getClientSortName,
} from "@/lib/utils/client-utils";

export const ClientSelect: React.FC<
	SelectProps & {
		filter?: (client: ClientEntityType) => boolean;
	}
> = (props) => {
	const organizationId = useCentralStore((state) => state.organization?.id);

	const {
		data: clients,
		loading,
		error,
	} = useDatabaseFetch(SupabaseReadTableEnum.CLIENTS_VIEW, {
		column: "organization_id",
		value: organizationId,
	});

	return (
		<>
			<CustomSelect
				options={
					clients
						?.filter((p) => !p.is_inactive)
						.filter(props.filter ?? (() => true))
						.filter((p) => p.id)
						.sort((a, b) => {
							const nameA =
								getClientSortName(a)?.toLowerCase() ?? "";
							const nameB =
								getClientSortName(b)?.toLowerCase() ?? "";
							return nameA.localeCompare(nameB);
						})
						.map((p: ClientEntityType) => ({
							value: p.id as string,
							label: getClientDisplayName(p),
						})) ?? []
				}
				inputLabel="Auftraggeber"
				{...props}
			/>
		</>
	);
};
